import React, { useState } from 'react'
import { Button, Modal, FormControl } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import styles from './ProjectSelectorModal.module.css'
import CustomModal from '../../CustomModal/CustomModal'
import { isWasmerFile } from '../../../utils/general'

const ProjectSelectorModal = ({ show, onHide, onSelectProject, customDomain }) => {
  const { liveSites } = useSelector((state) => state.manage)
  const [selectedSite, setSelectedSite] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')

  // PHP (Wasmer) projects have their own domain flow ("Publish to custom domain" in the project menu)
  const staticSites = liveSites?.filter((site) => {
    const domain = site?.subdomain || site?.link || ''
    return !domain.includes('tiiny.io') && !isWasmerFile(site)
  })
  const hasHiddenServerSites = staticSites?.length !== liveSites?.length

  const filteredSites = staticSites?.filter((site) => {
    const domain = site?.subdomain || site?.link || ''
    return domain.toLowerCase().includes(searchTerm.toLowerCase())
  })

  const handleSiteSelect = (site) => {
    setSelectedSite(site)
  }

  const handlePublish = () => {
    if (selectedSite) {
      onSelectProject(selectedSite)
    }
  }

  const handleClose = () => {
    setSelectedSite(null)
    setSearchTerm('')
    onHide()
  }

  return (
    <CustomModal show={show} onHide={handleClose} centered size="md" enforceFocus={false} backdrop="static">
      <div className={styles.modalContainer}>
        <button className={styles.closeButton} onClick={handleClose}>
          <img src="/delete.png" alt="Close" width="16" height="16" />
        </button>

        <div className={styles.headerContent}>
          <h2 className={styles.modalTitle}>Select Project to Publish</h2>
          <p className={styles.modalDescription}>
            Choose a project to publish to <strong>{customDomain}</strong>
          </p>
          {hasHiddenServerSites && (
            <p className={`${styles.modalDescription} mt-2`}>
              PHP projects aren&apos;t listed here. Use &quot;Publish to custom domain&quot; from the project&apos;s
              menu instead.
            </p>
          )}
        </div>

        {staticSites?.length > 4 && (
          <div className={styles.searchContainer}>
            <FormControl
              type="text"
              placeholder="Search projects..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.searchInput}
            />
          </div>
        )}

        <div className={styles.projectsList}>
          {filteredSites?.length > 0 ? (
            filteredSites.map((site) => {
              const domain = site?.subdomain || site?.link
              return (
                <div
                  key={domain}
                  className={`${styles.projectItem} ${selectedSite?.subdomain === site.subdomain ? styles.selected : ''}`}
                  onClick={() => handleSiteSelect(site)}
                >
                  <div className={styles.projectInfo}>
                    <div className={styles.projectName}>{domain}</div>
                    {site.filename && <div className={styles.projectFilename}>{site.filename}</div>}
                  </div>
                  <div className={styles.radioButton}>
                    <input
                      type="radio"
                      checked={selectedSite?.subdomain === site.subdomain}
                      onChange={() => handleSiteSelect(site)}
                    />
                  </div>
                </div>
              )
            })
          ) : (
            <div className={styles.emptyState}>
              <p>No projects found</p>
            </div>
          )}
        </div>

        <div className={styles.footerButtons}>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handlePublish} disabled={!selectedSite}>
            Continue
          </Button>
        </div>
      </div>
    </CustomModal>
  )
}

export default ProjectSelectorModal
